import axios from "vue-app/utils/axios";
import { DTOAutoresponderConfig } from "vue-app/api/dto";

export const getAutoresponderData = async () => {
  const { data } = await axios.get<Partial<DTOAutoresponderConfig>>("/inbox/autoresponder");
  return data;
};

export const editAutoresponderData = async (params: Partial<DTOAutoresponderConfig>) => {
  const { data } = await axios.put<Partial<DTOAutoresponderConfig>>("/inbox/autoresponder", params);
  return data;
};
